// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.event_dashboard__rGrnV {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.event_dashboardContain__pYMQl {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.event_bodythemedark__tg4iK .event_dashboardContain__pYMQl,
.event_bodythemedark__tg4iK .event_dashboard__rGrnV,
.event_bodythemedark__tg4iK .event_cont2__y\\+YNF {
  background-Color: #0f1824;
}

.event_top_header__GifRU .event_top_header_inner__EZWtt {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.event_cont2__y\\+YNF {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.event_subLink__WbYvp svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.event_cst_vendr__GUOgf input {
  min-height: 35px !important;
}

.event_cst_vendr__GUOgf .event_form-control__GA3iC {
  background-color: #f5f6fa;
  border: none;
}

.event_footer__lBqDR {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.event_bodythemelight__PnGyH {
  background-color: #fff;
  padding-top: 90px;
}

.event_bodythemedark__tg4iK {
  background-color: #132337;
  padding-top: 90px;
}

.event_bodythemeNew__fQJ-W {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.event_headerthemelight__E9if5 {
  background-color: #fff;
}

.event_headerthemedark__hhxuN {
  background-color: #132337;
}

.event_top_header__GifRU {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.event_menuthemelight__kH3z6 {
  background-color: #f5f6fa;
}

.event_menuthemedark__JzS5q {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.event_menulinklight__\\+wYM8 span {
  color: #666666 !important;
}

.event_menulinklight__\\+wYM8 a {
  color: #CBCBCB !important;
}

.event_menulinklight__\\+wYM8:hover span,
.event_menulinklight__\\+wYM8:hover a {
  color: #fff !important;
}

.event_menulinkdarkSelected__GmPax {
  background-color: #1c2e45;
  color: #3b82f6;
}

.event_menuthemelight__kH3z6 .event_menulinklightSelected__lyFHk {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.event_menulinkdark__2uQYo {
  color: #92afd3 !important;
}

.event_menulinklight__\\+wYM8:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.event_menulinklight__\\+wYM8 .event_sub_arrow__IMoFB svg path {
  stroke: #CBCBCB !important;
}

.event_menulinklight__\\+wYM8:hover .event_sub_arrow__IMoFB svg path {
  stroke: #fff !important;
}

.event_menulinkdark__2uQYo .event_sub_arrow__IMoFB svg path {
  stroke: #92afd3 !important;
}

.event_menulinkdark__2uQYo:hover .event_sub_arrow__IMoFB svg path {
  stroke: #fff !important;
}

.event_menulinklight__\\+wYM8:hover svg path,
.event_menulinklightSelected__lyFHk svg path {
  fill: #fff !important;
}

.event_menulinkdark__2uQYo:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.event_headinglight__QrVUe {
  color: #60677e;
}

.event_headingdark__wDIqa {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.event_searchboxlight__gRfoF {
  background-color: #fff;
  border: none;
}

.event_searchboxdark__NOEjW {
  background-color: #132337;
  color: #fff;
  border: none;
}

.event_searchboxdark__NOEjW::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.event_tableheadlight__jiX-E {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.event_tableheadlight__jiX-E th {
  color: #fff;
}

thead .event_tableheadlight__jiX-E th:first-child,
thead .event_tableheaddark__dxhJG th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .event_tableheadlight__jiX-E th:last-child,
thead .event_tableheaddark__dxhJG th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.event_table__fIg6a.event_table-borderless__Nr5Tg {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.event_tableheaddark__dxhJG {
  background-color: #132337;
  color: #fff;
}

.event_table-borderless__Nr5Tg tr:nth-child(even) {
  background-color: #F9FAFB;
}

.event_table-borderless__Nr5Tg .event_left-section__wYhSf {
  padding-top: 10px;
}

.event_tablebodylight__kVWpq td,
.event_tablebodydark__3Bblw td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.event_tablebodylight__kVWpq {
  background-color: #fff;
}
.event_tablebodylight__kVWpq:hover {
  background-color: #fff;
  cursor: auto;
}
.event_tablebodylight__kVWpq p {
  line-height: 24px;
}

.event_tablebodydark__3Bblw {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.event_tablebodydark__3Bblw:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.event_paginationlight__zWXYl {
  color: #60677e !important;
  font-size: 13px !important;
}

.event_paginationdark__8L-KE {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.event_formthemelight__R7ryl {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.event_formthemedark__w8bkP {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.event_formthemedark__w8bkP ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.event_viewformlight__fFsxi {
  background-color: #f3f6f9;
}

.event_permissionboxlight__UrakP {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.event_permissionboxdark__NZfFR {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.event_errormsgclr__xOFjp {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.event_graphclrlight__hpfEh {
  background-color: #fff;
}

.event_graphclrdark__nmnBw {
  background-color: #132337;
}

/* 
Counter theme
*/
#event_card1bglight__fjnch {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#event_card1bgdark__1viO7 {
  background: #392f28;
}

#event_card2bglight__YQzdV {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#event_card2bgdark__h-SQj {
  background: #1c3238;
}

#event_card3bglight__4RjGH {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#event_card3bgdark__JdpGi {
  background: #3a2434;
}

#event_card4bglight__ZXzhc {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#event_card4bgdark__XWWt0 {
  background: #2f264f;
}

#event_card1bgdark__1viO7 a,
#event_card1bgdark__1viO7 p,
#event_card2bgdark__h-SQj a,
#event_card2bgdark__h-SQj p,
#event_card3bgdark__JdpGi a,
#event_card3bgdark__JdpGi p,
#event_card4bgdark__XWWt0 a,
#event_card4bgdark__XWWt0 p {
  color: #fff;
}

/* 
Action button theme
*/
.event_actionbtnlight__EJBik {
  color: rgba(70, 71, 91, 0.8705882353);
}

.event_actionbtndark__\\+Hw5Z {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.event_profiledropdownlight__od0xL {
  background-color: #fff;
}

.event_profiledropdowndark__1CFq6 {
  background-color: #151521;
}

.event_settingsection__xurBv #event_addform__lyjtP.event_formthemedark__w8bkP .event_savebtn__79bI2 {
  background-color: #3b82f6;
  color: #fff;
}

#event_addform__lyjtP.event_formthemedark__w8bkP .event_savebtn__79bI2 {
  background-color: #3b82f6;
  color: #fff;
}

.event_profile_conatiner__SCOqd {
  border-radius: 5px !important;
}

.event_bodythemedark__tg4iK .event_ag-theme-alpine__doxwI .event_ag-row__bY9Uj {
  background: #000 !important;
}

.event_bodythemedark__tg4iK .event_formbtn__wS4tG {
  background-color: #3b82f6;
}

.event_bodythemedark__tg4iK .event_formbtn__wS4tG:hover {
  background-color: #2563eb;
}

.event_bodythemedark__tg4iK .event_resetbtn__TnFbb {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.event_bodythemedark__tg4iK .event_resetbtn__TnFbb:hover {
  background-color: #3b82f6;
}

.event_headingdark__wDIqa span {
  background-color: #132337;
}

.event_resetbtn__TnFbb {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.event_resetbtn__TnFbb:hover,
.event_resetbtn__TnFbb:active,
.event_resetbtn__TnFbb:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.event_addBtn__tLuFn {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.event_addDltBtn__gQUPI {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.event_addbtnlight__PHprB {
  background-color: #38A169;
}

.event_addbtndark__Q170\\+ {
  background-color: #3b82f6;
}

.event_addbtndark__Q170\\+:hover {
  background-color: #2563eb;
}

.event_formthemedark__w8bkP label {
  color: #92afd3;
}

.event_addBtn__tLuFn svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.event_addBtn__tLuFn:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.event_cust_addBtn__fHoB7.event_addBtn__tLuFn svg {
  top: 2px;
}

.event_deleteBtn__iSlpx {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.event_deleteBtn__iSlpx {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.event_deleteBtn__iSlpx:active,
.event_deleteBtn__iSlpx:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.event_deleteBtn__iSlpx svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.event_deleteBtn__iSlpx:hover,
.event_deleteBtn__iSlpx:active,
.event_deleteBtn__iSlpx:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.event_confirmBtn__dV\\+Ge {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.event_confirmBtn__dV\\+Ge:hover,
.event_confirmBtn__dV\\+Ge:active,
.event_confirmBtn__dV\\+Ge:focus {
  background-color: #0f1824 !important;
}

.event_confirmBtn__dV\\+Ge svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.event_delPopContainer__Av4jI .event_modal-body__LDvst {
  padding: 35px;
  text-align: center;
}

.event_delPopContainer__Av4jI .event_delet_icon__l7PSw {
  margin-bottom: 11px;
}

.event_delPopContainer__Av4jI p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.event_arrowback__BxenL svg {
  fill: #000;
}

.event_bodythemedark__tg4iK .event_arrowback__BxenL {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.event_bodythemedark__tg4iK .event_arrowback__BxenL svg {
  fill: #3b82f6;
}

.event_bodythemedark__tg4iK .event_drpdwn_btn__C7XE3 {
  background-color: #132337;
}

.event_bodythemedark__tg4iK .event_empname__MDvbB {
  color: #92afd3 !important;
}

.event_bodythemedark__tg4iK .event_navitemli__qa4SG a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.event_bodythemedark__tg4iK .event_tabnavli__zxS1d a.event_settingsgeneral__AGuDg,
.event_bodythemedark__tg4iK .event_tabnavli__zxS1d a.event_settingslinks__fiygB:hover {
  background-color: #3b82f6;
  color: #fff;
}

.event_bodythemedark__tg4iK .event_tabnavli__zxS1d a.event_settingslinks__fiygB {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o {
  background-color: #1c2e45;
  color: #fff;
}

.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o ul li a,
.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o .event_dropdown_item__1mtko,
.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o .event_dropdown_item__1mtko h5 {
  color: #fff;
}

.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o ul li a:hover,
.event_headerthemedark__hhxuN .event_dropdown_menu_contain__SVh0o .event_dropdown_item__1mtko:hover {
  background-color: #132337;
  color: #fff;
}

.event_dropdown_item__1mtko:active {
  background-color: #F5F6FA;
}

.event_profile_arrrow_dwn__oZSX8 {
  stroke: #132337;
}

.event_headerthemedark__hhxuN .event_profile_arrrow_dwn__oZSX8 {
  stroke: #fff;
}

.event_dateinputbox1__bV0Kv input,
.event_dateinputbox1__bV0Kv span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.event_delPopContainer__Av4jI .event_modal-content__79bFJ {
  border-radius: 10px;
  min-width: 399px;
}

.event_larg_model__Tfxaq .event_modal-dialog__iixcE {
  max-width: 100% !important;
}

.event_larg_model__Tfxaq .event_modal-content__79bFJ {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.event_larg_model__Tfxaq .event_modal-header__Ylisg {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .event_btn-primary__EsDCP:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.event_form-select__\\+2PAU {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .event_CustomTable_tableheadlight__HuHZw__siXZ0 th:first-child,
thead .event_CustomTable_tableheaddark__nwqb4__plAU0 th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .event_tableheadlight__jiX-E th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .event_dashboard__rGrnV {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .event_cont2__y\\+YNF {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .event_sectionright__YNf90 {
    float: unset !important;
  }
  .event_dashboard__rGrnV {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .event_cont2__y\\+YNF {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .event_bodythemelight__PnGyH,
.event_bodythemedark__tg4iK {
    padding-top: 110px;
  }
  .event_delPopContainer__Av4jI .event_modal-content__79bFJ {
    min-width: 100%;
  }
  .event_delPopContainer__Av4jI .event_modal-body__LDvst {
    padding: 15px;
  }
  .event_larg_model__Tfxaq .event_modal-content__79bFJ {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .event_exer_modal_contain__OgdPh .event_modal-dialog__iixcE {
    max-width: 1055px;
  }
  .event_delPopContainer__Av4jI .event_modal-dialog__iixcE {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.event_active_show_outer__BL62E h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .event_active_show_outer__BL62E h2 {
    margin-top: 15px;
  }
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C {
  width: 100%;
  display: block;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_img__yl2Wd {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_img__yl2Wd {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_img__yl2Wd img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT {
  width: 100%;
  display: block;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT svg {
  flex-shrink: 0;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT .event_act_box_bdg__Qti\\+A {
  width: 100%;
  margin-bottom: 12px;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT .event_act_box_bdg__Qti\\+A span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT .event_act_box_bdg__Qti\\+A .event_sold__hsEBT {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.event_active_show_outer__BL62E .event_active_show_inner__-hO3C .event_act_box_cnt__t8DjT p .event_timezone_code_pill__QtaUw {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#event_attent_details_row1__pQjkJ {
  margin-bottom: 0 !important;
}

.event_attent_details__rCWwG .event_attent_details_inner__y1lwq {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .event_attent_details__rCWwG .event_attent_details_inner__y1lwq {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .event_attent_details__rCWwG .event_attent_details_inner__y1lwq {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_l__t4vfq img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY {
  flex: 1 1;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 .event_attent_details_row_box__scuAN {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 .event_attent_details_row_box__scuAN {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 .event_attent_details_row_box__scuAN {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 .event_attent_details_row_box__scuAN p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row__dcbz8 .event_attent_details_row_box__scuAN h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row_last__68nua {
  margin-bottom: 0px !important;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row_last__68nua.event_interesting_fact__zjUmn {
  padding-top: 30px;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row_last__68nua.event_interesting_fact__zjUmn .event_attent_details_row_box__scuAN {
  width: 100%;
}
.event_attent_details__rCWwG .event_attent_details_inner__y1lwq .event_attent_details_inner_r__8QCuY .event_attent_details_row_last__68nua.event_interesting_fact__zjUmn .event_attent_details_row_box__scuAN h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.event_showbox_sec__o2deK {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .event_showbox_sec__o2deK {
    justify-content: center;
  }
}

.event_show_box_main__6Ek41 {
  margin: 10px 0px;
}
.event_show_box_main__6Ek41 .event_show_box__bsUVP {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .event_show_box_main__6Ek41 .event_show_box__bsUVP {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .event_show_box_main__6Ek41 .event_show_box__bsUVP {
    min-height: 500px;
    width: 200px !important;
  }
}
.event_show_box_main__6Ek41 .event_show_box__bsUVP img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .event_show_box_main__6Ek41 .event_show_box__bsUVP img {
    max-height: 300px !important;
  }
}
.event_show_box_main__6Ek41 .event_show_box__bsUVP:last-child {
  margin-right: 0px !important;
}
.event_show_box_main__6Ek41 .event_no_show_box__eFd-I {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .event_show_box_main__6Ek41 .event_no_show_box__eFd-I {
    width: 250px !important;
  }
}
.event_show_box_main__6Ek41 .event_no_show_box__eFd-I img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .event_show_box_main__6Ek41 .event_no_show_box__eFd-I img {
    max-height: 350px !important;
  }
}
.event_show_box_main__6Ek41 .event_no_show_box__eFd-I h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .event_show_box_main__6Ek41 .event_no_show_box__eFd-I h6 {
    font-size: 20px;
  }
}

.event_attent_flex__mjzfs {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.event_attent_flex__mjzfs h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.event_indexdiv__bfI9a #event_addheading__yr7\\+l {
  font-size: 18px;
  margin-bottom: 20px;
}
.event_indexdiv__bfI9a .event_exportsection__pkojg {
  float: right;
  width: 100%;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  #event_dashboardcont2__eG\\+bV {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/event/index.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAxlCI;EACI,eAAA;EACA,mBAAA;AA2lCR;AAzlCI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AA2lCR;;AArlCA;EACI;IACI,wBDmEI;IClEJ,UDmEG;IClEH,kBAAA;IACA,aD2DW;EC6hCjB;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.indexdiv{\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n    .exportsection{\n        float: right;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n}\n  \n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `event_dashboard__rGrnV`,
	"dashboardContain": `event_dashboardContain__pYMQl`,
	"bodythemedark": `event_bodythemedark__tg4iK`,
	"cont2": `event_cont2__y+YNF`,
	"top_header": `event_top_header__GifRU`,
	"top_header_inner": `event_top_header_inner__EZWtt`,
	"subLink": `event_subLink__WbYvp`,
	"cst_vendr": `event_cst_vendr__GUOgf`,
	"form-control": `event_form-control__GA3iC`,
	"footer": `event_footer__lBqDR`,
	"bodythemelight": `event_bodythemelight__PnGyH`,
	"bodythemeNew": `event_bodythemeNew__fQJ-W`,
	"headerthemelight": `event_headerthemelight__E9if5`,
	"headerthemedark": `event_headerthemedark__hhxuN`,
	"menuthemelight": `event_menuthemelight__kH3z6`,
	"menuthemedark": `event_menuthemedark__JzS5q`,
	"menulinklight": `event_menulinklight__+wYM8`,
	"menulinkdarkSelected": `event_menulinkdarkSelected__GmPax`,
	"menulinklightSelected": `event_menulinklightSelected__lyFHk`,
	"menulinkdark": `event_menulinkdark__2uQYo`,
	"sub_arrow": `event_sub_arrow__IMoFB`,
	"headinglight": `event_headinglight__QrVUe`,
	"headingdark": `event_headingdark__wDIqa`,
	"searchboxlight": `event_searchboxlight__gRfoF`,
	"searchboxdark": `event_searchboxdark__NOEjW`,
	"tableheadlight": `event_tableheadlight__jiX-E`,
	"tableheaddark": `event_tableheaddark__dxhJG`,
	"table": `event_table__fIg6a`,
	"table-borderless": `event_table-borderless__Nr5Tg`,
	"left-section": `event_left-section__wYhSf`,
	"tablebodylight": `event_tablebodylight__kVWpq`,
	"tablebodydark": `event_tablebodydark__3Bblw`,
	"paginationlight": `event_paginationlight__zWXYl`,
	"paginationdark": `event_paginationdark__8L-KE`,
	"formthemelight": `event_formthemelight__R7ryl`,
	"formthemedark": `event_formthemedark__w8bkP`,
	"viewformlight": `event_viewformlight__fFsxi`,
	"permissionboxlight": `event_permissionboxlight__UrakP`,
	"permissionboxdark": `event_permissionboxdark__NZfFR`,
	"errormsgclr": `event_errormsgclr__xOFjp`,
	"graphclrlight": `event_graphclrlight__hpfEh`,
	"graphclrdark": `event_graphclrdark__nmnBw`,
	"card1bglight": `event_card1bglight__fjnch`,
	"card1bgdark": `event_card1bgdark__1viO7`,
	"card2bglight": `event_card2bglight__YQzdV`,
	"card2bgdark": `event_card2bgdark__h-SQj`,
	"card3bglight": `event_card3bglight__4RjGH`,
	"card3bgdark": `event_card3bgdark__JdpGi`,
	"card4bglight": `event_card4bglight__ZXzhc`,
	"card4bgdark": `event_card4bgdark__XWWt0`,
	"actionbtnlight": `event_actionbtnlight__EJBik`,
	"actionbtndark": `event_actionbtndark__+Hw5Z`,
	"profiledropdownlight": `event_profiledropdownlight__od0xL`,
	"profiledropdowndark": `event_profiledropdowndark__1CFq6`,
	"settingsection": `event_settingsection__xurBv`,
	"addform": `event_addform__lyjtP`,
	"savebtn": `event_savebtn__79bI2`,
	"profile_conatiner": `event_profile_conatiner__SCOqd`,
	"ag-theme-alpine": `event_ag-theme-alpine__doxwI`,
	"ag-row": `event_ag-row__bY9Uj`,
	"formbtn": `event_formbtn__wS4tG`,
	"resetbtn": `event_resetbtn__TnFbb`,
	"addBtn": `event_addBtn__tLuFn`,
	"addDltBtn": `event_addDltBtn__gQUPI`,
	"addbtnlight": `event_addbtnlight__PHprB`,
	"addbtndark": `event_addbtndark__Q170+`,
	"cust_addBtn": `event_cust_addBtn__fHoB7`,
	"deleteBtn": `event_deleteBtn__iSlpx`,
	"confirmBtn": `event_confirmBtn__dV+Ge`,
	"delPopContainer": `event_delPopContainer__Av4jI`,
	"modal-body": `event_modal-body__LDvst`,
	"delet_icon": `event_delet_icon__l7PSw`,
	"arrowback": `event_arrowback__BxenL`,
	"drpdwn_btn": `event_drpdwn_btn__C7XE3`,
	"empname": `event_empname__MDvbB`,
	"navitemli": `event_navitemli__qa4SG`,
	"tabnavli": `event_tabnavli__zxS1d`,
	"settingsgeneral": `event_settingsgeneral__AGuDg`,
	"settingslinks": `event_settingslinks__fiygB`,
	"dropdown_menu_contain": `event_dropdown_menu_contain__SVh0o`,
	"dropdown_item": `event_dropdown_item__1mtko`,
	"profile_arrrow_dwn": `event_profile_arrrow_dwn__oZSX8`,
	"dateinputbox1": `event_dateinputbox1__bV0Kv`,
	"modal-content": `event_modal-content__79bFJ`,
	"larg_model": `event_larg_model__Tfxaq`,
	"modal-dialog": `event_modal-dialog__iixcE`,
	"modal-header": `event_modal-header__Ylisg`,
	"btn-primary": `event_btn-primary__EsDCP`,
	"form-select": `event_form-select__+2PAU`,
	"CustomTable_tableheadlight__HuHZw": `event_CustomTable_tableheadlight__HuHZw__siXZ0`,
	"CustomTable_tableheaddark__nwqb4": `event_CustomTable_tableheaddark__nwqb4__plAU0`,
	"sectionright": `event_sectionright__YNf90`,
	"exer_modal_contain": `event_exer_modal_contain__OgdPh`,
	"active_show_outer": `event_active_show_outer__BL62E`,
	"active_show_inner": `event_active_show_inner__-hO3C`,
	"act_box_img": `event_act_box_img__yl2Wd`,
	"act_box_cnt": `event_act_box_cnt__t8DjT`,
	"act_box_bdg": `event_act_box_bdg__Qti+A`,
	"sold": `event_sold__hsEBT`,
	"timezone_code_pill": `event_timezone_code_pill__QtaUw`,
	"attent_details_row1": `event_attent_details_row1__pQjkJ`,
	"attent_details": `event_attent_details__rCWwG`,
	"attent_details_inner": `event_attent_details_inner__y1lwq`,
	"attent_details_inner_l": `event_attent_details_inner_l__t4vfq`,
	"attent_details_inner_r": `event_attent_details_inner_r__8QCuY`,
	"attent_details_row": `event_attent_details_row__dcbz8`,
	"attent_details_row_box": `event_attent_details_row_box__scuAN`,
	"attent_details_row_last": `event_attent_details_row_last__68nua`,
	"interesting_fact": `event_interesting_fact__zjUmn`,
	"showbox_sec": `event_showbox_sec__o2deK`,
	"show_box_main": `event_show_box_main__6Ek41`,
	"show_box": `event_show_box__bsUVP`,
	"no_show_box": `event_no_show_box__eFd-I`,
	"attent_flex": `event_attent_flex__mjzfs`,
	"indexdiv": `event_indexdiv__bfI9a`,
	"addheading": `event_addheading__yr7+l`,
	"exportsection": `event_exportsection__pkojg`,
	"dashboardcont2": `event_dashboardcont2__eG+bV`
};
export default ___CSS_LOADER_EXPORT___;
